export default "__VITE_ASSET__CHeSbvSN__"